/* src/app/pages/project/map/repository/import-wizard/components/geospatial/_components/minimap/import-wizard-geospatial-minimap.component.scss */
#map {
  width: 100%;
  height: 100%;
  min-height: 400px;
  background: #414141;
}
/*# sourceMappingURL=import-wizard-geospatial-minimap.component-5RU7BPXM.css.map */
